import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ellipsis_beadd51b8c329001ca29606222e96f5b",
  "use": "ellipsis_beadd51b8c329001ca29606222e96f5b-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ellipsis_beadd51b8c329001ca29606222e96f5b\">\n    <path fill-rule=\"evenodd\" d=\"M10.25 12a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0zM4 12a1.75 1.75 0 1 1 3.5 0A1.75 1.75 0 0 1 4 12zm12.5 0a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol